export const getTipoPago = tipo => {
  if (tipo === 'Tarifa') return 'pago-tarifa'
  if (tipo === 'Intensivo') return 'pago-intensivo'
  if (tipo === 'Pack Horas') return 'pago-pack-horas'
  return 'pago'
}
